export default Object.freeze({
    woosmapKey: 'woos-5ec4eecd-d907-3da0-90f0-f2f3b7e4e672',
    geolocationWoosmapSearchKey: 'woos-81a699ca-5082-3ffd-9f54-a684a4b82853',
    gmapKey: 'AIzaSyAogtvSQJ8e1LO6WH6GzSI-QtwaRPCV5C8',
    woosmapMapSdkUrl: 'https://sdk.woosmap.com/map/map.js',
});
